// extracted by mini-css-extract-plugin
export default {"root":"App_root__AKQee","body":"App_body__PKxV8","placeHolderShimmer":"App_placeHolderShimmer__YHbHd"};